<template>
    <div class="sticky">
        <ul class="ps-0 for_desktop">
            <li><NuxtLink :to="localePath('/terms-of-service')">Terms & Conditions</NuxtLink></li>
            <li><NuxtLink :to="localePath('/privacy-policy')">Privacy Policy</NuxtLink></li>
            <li><NuxtLink :to="localePath('/cookie-policy')">Cookie Policy</NuxtLink></li>
        </ul>
        <div class="for_mobile mb-5">
            <FilterCustomDropDown 
                type="policymenu" 
                :routeOptions="routeOptions"
                :modelValue="defaultModelValue"
            />
        </div>
    </div>
</template>

<script setup>
    const localePath = useLocalePath();
    const defaultModelValue = ref('')

    const routeOptions = {
        '/terms-of-service': 'Terms & Conditions',
        '/privacy-policy': 'Privacy Policy',
        '/cookie-policy': 'Cookie Policy'
    };
 
</script>

<style scoped>
 ul li{
    list-style: none;
    padding: 2px 0;
}
ul li a {
    color: #000;
    font-weight: 600;
    line-height: 2;
    text-transform: uppercase;
    font-size: 13px;
}
 li a.router-link-active.router-link-exact-active{
    color: #508a7b;
}

@media(min-width: 768px){
    .sticky{
        position: sticky;
        top: 30px;
        height: -webkit-fit-content;
        height: -moz-fit-content;
        height: fit-content;
    }
}

@media (max-width: 767px){
      /* Sort Drop */
  .label_box a .svg-head {
    margin: 0 0 -2px 9px;
    }
    p{
        font-size: 12px;
        font-weight: 600;
    }
    p a{
        color: var(--green);
    }
    .arr_box svg.svg-head {
        height: 16px;
    }
    .drop_block.invalid .current_active {
        border: 1px solid rgb(255, 2, 2);
    }
    .label_box {
        font-size: 14px;
        font-weight: 600;
        text-transform: capitalize;
        color: #212529;
    }
    .label_box div{
        color: rgb(159, 158, 158);
        cursor: pointer;
    }
    .drop_block{
        position: relative;
    }
    .current_active {
        display: flex;
        align-items: center;
        justify-content: space-between;
        line-height: 1.5;
        color: #000;
        vertical-align: middle;
        padding: 0 10px;
        font-size: 14px;
        cursor: pointer;
        height: 44px;
        border-radius: 8px;
        border: 1px solid #c4c4c4;
    }

    label {
        font-size: 16px;
        color: #303030;
        line-height: 1.3;
    }
    .current_active.focused {
        border-color: var(--green);
        box-shadow: 0 0 0 0.2rem rgb(112 192 153 / 25%);
    }
    ul {
        border: 1px solid #c4c4c4;
        position: absolute;
        top: 100%;
        left: 0%;
        width: 100%;
        background: #fff;
        z-index: 9;
        padding: 10px 0;
        max-height: 220px;
        overflow: auto;
        border-radius: 8px;
    }
    ul li{
        list-style: none;
        padding: 5px 10px;
        cursor: pointer;
        display: flex;
        align-items: center;
        text-transform: capitalize;
    }
    ul li.active {
        border-color: var(--green);
    }
    span{
        font-weight: 400;
        font-size: 14px;
        color: #212529;
        text-transform: capitalize;
    }

    ul li.disabled {
        pointer-events: none;
        opacity: 0.5;
    }

    /* Sort Drop */
}
</style>
